import { __read, __spreadArray } from "tslib";
import { from } from '../observable/from';
import { mergeAll } from '../operators/mergeAll';
import { operate } from '../util/lift';
export function mergeWith() {
    var otherSources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        otherSources[_i] = arguments[_i];
    }
    return operate(function (source, subscriber) {
        mergeAll()(from(__spreadArray([source], __read(otherSources), false))).subscribe(subscriber);
    });
}
//# sourceMappingURL=mergeWith.js.map